<a 
  href="https://app.addmeetings.com/register" 
  class="inline-flex items-center gap-1 bg-[#536aff] text-white h-[40px] px-4 py-2 rounded-full hover:bg-[#4444ff] transition-colors font-medium"
>
  <slot />
  <span 
    class="material-symbols-rounded"
    style="font-size: 20px; font-variation-settings: 'FILL' 0, 'wght' 300;"
  >arrow_forward</span>
</a>